"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedType = void 0;
var FeedType;
(function (FeedType) {
    FeedType["RSS"] = "rss";
    FeedType["OTHER"] = "other";
    FeedType["ATOM"] = "atom";
    FeedType["LATEST_HAIRSTYLES"] = "latest_hairstyles";
    FeedType["ASTROSTYLE"] = "astrostyle";
    FeedType["LATEST_HAIRSTYLES_XML"] = "latest_hairstyles_xml";
    FeedType["HIVE_CSV"] = "hive_csv";
    FeedType["RSS_BS4"] = "rss_bs4";
    FeedType["HTML"] = "html";
    FeedType["ACCUWEATHER_AUTOMATOR"] = "accuweather_automator";
    FeedType["ASTROLOGY"] = "astrology";
    FeedType["HOWSTUFFWORKS"] = "howstuffworks";
    FeedType["HOWSTUFFWORKS_AUTOMATOR"] = "howstuffworks_automator";
    FeedType["GALVANIZED"] = "galvanized";
    FeedType["JSON"] = "json";
    FeedType["PATCH"] = "patch";
    FeedType["HOROSCOPE"] = "horoscope";
    FeedType["XML"] = "xml";
})(FeedType = exports.FeedType || (exports.FeedType = {}));
//# sourceMappingURL=feed-type.js.map